import { mapGetters } from 'vuex'
import Add from './add.dialog.vue'
import team from '../../../../api/team'
const columns = [
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Avatar',
    width: 100,
    dataIndex: 'icon',
    slot: 'avatar'
  },
  {
    title: '',
    enTitle: 'Roles',
    width: 150,
    dataIndex: 'identityCode',
    slot: 'roles'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Title',
    width: 80,
    dataIndex: 'titleCode',
    slot: 'title'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 170,
    dataIndex: 'createdTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 170,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    Add
  },
  data() {
    return {
      columns,
      isVisable: false,
      dataSource: [],
      params: {
        released: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      title: 'getTitle',
      managementTeam: 'getManagementTeam',
      language: 'getLanguage',
      domain: 'getDomain',
      user: 'getUser'
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.dataSource = await team.getAll(this.params)
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    add() {
      this.isVisable = true
    },
    edit(val) {
      this.$refs['management-team-add'].getQuery(val.id)
      this.isVisable = true
    },
    async able(val) {
      const { id, released, version } = val
      await team.release(id, !released, { version })
      let content = 'This Management Team has been published!'
      if (released) {
        content = 'This Management Team has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this management team?',
        content:
          'Please be aware of once this management team is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await team.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Management Team has been deleted!'
        })
        this.getList()
      })
    },
    async setSort(val) {
      val.forEach((item, index) => {
        item.sort = index
      })
      await team.setSort(val)
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    }
  }
}
